// extracted by mini-css-extract-plugin
module.exports = {"shopifyPreview":"styles_shopifyPreview__gT8Sw","firstRiverOnPage":"styles_firstRiverOnPage__yhjqh"};